var AclGroup = function(opts){
	var self = this;
	self.id = ko.observable(parseInt(opts.id || 0));
	self.name = ko.observable(opts.name || '');
	self.url = ko.observable(opts.url || '');
	self.access = ko.observable(parseInt(opts.access || 0));
	self.selected = ko.observable(false);
};